import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');

    if ($navbar) {
        const $documentElement = document.documentElement;
        let lastScrollTop = 0;

        const handleScroll = () => {
            const currentScrollTop = window.scrollY;
            if (currentScrollTop === 0) {
                $documentElement.classList.add('is-top');
            } else {
                $documentElement.classList.remove('is-top');
            }
            if (currentScrollTop <= lastScrollTop) {
                $navbar.classList.add('is-fixed-top');
                $documentElement.classList.add('has-navbar-fixed-top');
            } else {
                $navbar.classList.remove('is-fixed-top');
                $documentElement.classList.remove('has-navbar-fixed-top');
            }

            lastScrollTop = Math.max(0, currentScrollTop);
        };

        const debouncedHandleScroll = debounce(handleScroll, 100);

        document.addEventListener('scroll', debouncedHandleScroll);
    }
});
